export enum SpellLearningMethods {
    Wizard = 'wizard',
    School = 'school',
    AdaptedCantrip = 'adaptedcantrip',
    AdaptiveAdept = 'adaptiveadept',
    EsotericPolymath = 'esotericpolymath',
    ArcaneEvolution = 'arcaneevolution',
    LearnASpell = 'free',
}
